import React from 'react';
import Icon from 'ui/Icon';
import Spinner from 'ui/Spinner';
import request from 'utils/request_ajax';
import Header from './Header';
import DemonstrationViewerContent from './Content';
import DemonstrationSubmissions from './Submission/Submissions';

class DemonstrationViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previousAttempts: [],
      status: '',
      loading: true,
      feedbackCriteria: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    request.get(`${window.location.pathname}.json`).then(data => {
      this.setState(state => ({
        previousAttempts: [
          ...state.previousAttempts,
          ...data.demonstration.previousAttempts,
        ],
        feedbackCriteria: [
          ...state.feedbackCriteria,
          ...data.demonstration.feedbackCriteria,
        ],
        loading: false,
        status: data.demonstration.status,
      }));
    });
  }

  render() {
    const { demonstration, path, graders, user } = this.props;

    return (
      <>
        <div className="DemonstrationViewer container ff-ss">
          <div className="pb-16">
            <a className="fz-16 lh-24 c-brand-blue" href={`/path/${path.id}`}>
              <Icon name="back" className="mr-4" />
              {t('demonstrations.go_back_to_certification')}
            </a>
          </div>
          <div className="Card bg-white">
            <Header title={demonstration.title} />
            <DemonstrationViewerContent
              {...this.props}
              graders={graders}
              demonstration={demonstration}
              feedbackCriteria={this.state.feedbackCriteria}
            />
          </div>
          <span className="DemonstrationViewerCard-break" />
        </div>
        <div className="DemonstrationViewerSubmission Card bg-white w-fill">
          {this.state.loading ? (
            <Spinner />
          ) : (
            <DemonstrationSubmissions
              {...this.props}
              progresses={this.state.progresses}
              demonstration={demonstration}
              path={path}
              user={user}
              previousAttempts={this.state.previousAttempts}
              status={this.state.status}
            />
          )}
        </div>
      </>
    );
  }
}

export default DemonstrationViewer;
